<app-details-panel-shell
  *ngIf="entry"
  [visible]="visible"
  [showEditButton]="false"
  title=" "
  (onClose)="onClose.emit()"
>
  <app-gpd-button toolbarStart type="text" [text]="labelOpenTask" (onClick)="onOpenTask.emit()"></app-gpd-button>

  <div class="data-tab">
    <div class="header">
      <span>{{ labelTaskDetails }}</span>
    </div>
    <div class="sort">
      <div class="data-item">
        <span class="field-label">{{ labelName }}</span>
        <span>{{ entry.title }}</span>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelAssignedTo }}</span>
        <span *ngIf="assigneeDisplayName; else noAssignee" class="holder">
          <app-svg-icon *ngIf="heldByDepartment" icon="user-multiple" [size]="18" color="var(--color-primary)"></app-svg-icon>
          {{ assigneeDisplayName }}
        </span>
        <ng-template #noAssignee>
          <span class="holder-unassigned">{{ roleName || '—' }}</span>
        </ng-template>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelPriority }}</span>
        <app-priority-pill [value]="$safeNavigationMigration(task?.priority)" [editable]="false"></app-priority-pill>
      </div>
      <div class="data-item">
        <span class="field-label">{{ labelStatus }}</span>
        <app-status-pill *ngIf="task?.status" [statusId]="$safeNavigationMigration(task?.status)" [statusConfig]="taskStatusConfig"></app-status-pill>
      </div>
    </div>
  </div>

  <div class="data-tab">
    <div class="header">
      <span>{{ labelComments }}</span>
    </div>
    <div class="comment-list" *ngIf="comments.length > 0; else noComments">
      <div class="comment-item" *ngFor="let comment of comments">
        <div class="comment-meta">
          <span class="comment-author">{{ comment.createdByUser }}</span>
          <span class="comment-date">{{ comment.createdDate | date:'dd.MM.yyyy HH:mm' }}</span>
        </div>
        <div class="comment-text" [innerHTML]="comment.commentText"></div>
      </div>
    </div>
    <ng-template #noComments>
      <p class="comment-empty">{{ labelNoComments }}</p>
    </ng-template>
  </div>

</app-details-panel-shell>
